import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { stockCategoryPrimaryList, stockCategorySingleData, stockCategoryUpdate, openModal, closeModal } from '../../../../../redux/actions/action-creator';
import { toast } from 'react-toastify';
import FormData from 'form-data';
import MasterListFooter from '../../../../../components/Footer/Master_Footer/MasterListFooter';
import Form from '../../../../../components/Form/Form';

function StockCatagoryView({ data_to_view, title, closeModal_sec }) {

  const dispatch = useDispatch();
  const [load, setLoad] = useState(false)

  const { stock_category_under_data = [] } = useSelector(state => state.common);
  const { userData = null } = useSelector(state => state.auth);
  const modal_state = useSelector(state => state.common.modal_state);
  const filteredCategoryData = stock_category_under_data?.filter(item => item.id !== data_to_view?.id) || [];
  const initialState = {
    name: '',
    alias_name: '',
    under: 'Primary',
    stock_category_under_id: 'Primary',
    company_id: userData?.id
  }
  const [data, setData] = useState(initialState);

  useEffect(() => {
    setLoad(true)
    const formData = new FormData();
    formData.append('id', data_to_view?.id);
    formData.append('company_id', userData?.id);
    dispatch(stockCategorySingleData(formData)).then((response) => {
      if (response?.status) {
        setData({
          name: response.data?.name,
          alias_name: response.data?.alias_name,
          stock_category_under_id: response.data?.under_name ? response?.data?.under_name : 'Primary',
          under: response.data?.under,
          company_id: userData?.id,
          id: data_to_view?.id
        })
        setLoad(false)
      }
      else {
        toast.warn(response?.message || 'Fail !', {
          position: toast.POSITION.TOP_CENTER
        });
      }
    }).catch(error => {
      console.log(error)
      toast.error(error?.Responsemessage || ' Failed!', {
        position: toast.POSITION.TOP_CENTER
      });
    })
  }, [])

  return (
    <Form
      title='Stock Category View'
      loading={load}
      col='col-7'
      Footer={MasterListFooter}
    >
      <div className='row p-0 ps-2 m-0 mb-1'>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Name
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
          style={{ textAlign: "left" }}
        >
          {data?.name}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Alise
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.alias_name}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Under
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.stock_category_under_id}
        </div>
      </div>
    </Form>
  )
}

export default StockCatagoryView

